import varianceAnalysisConstants from "../constants";

export const formatReportingUnitsData = (rawRows, page, limit) => {
  const formattedArray = [];
  const ruCodeNameMap = {};
  const ruCodeIdMap = {};

  rawRows.forEach((unitItem, unitIndex) => {
    ruCodeNameMap[unitItem.code] = unitItem.name;
    ruCodeIdMap[unitItem.code] = unitItem._id;
    formattedArray.push({
      __key: unitIndex,
      __formatedkey: unitIndex,
      _id: unitItem._id,
      indexno: ((page || 0) * (limit || 50)) + unitIndex + 1,
      code: unitItem.code,
      name: unitItem.name,
      allusersset: unitItem.allusersset,
      materialityset_actual: unitItem.materialityset_actual,
      materialityset_forecast: unitItem.materialityset_forecast,
      materialityflag_actual: unitItem.materialityset_actual === true ? "Yes" : "No",
      materialityflag_forecast: unitItem.materialityset_forecast === true ? "Yes" : "No",
      network: (unitItem.network_detail || {}).name || "NA",
      region: (unitItem.region_detail || {}).name || "NA",
      country: (unitItem.country_detail || {}).name || "NA",
      localcontrol_proforma: unitItem.localcontrol_proforma || false,
      localmanagement_proforma: unitItem.localmanagement_proforma || false,
      regionalcontrol_proforma: unitItem.regionalcontrol_proforma || false,
      regionalmanagement_proforma: unitItem.regionalmanagement_proforma || false,
      localcontrol_forecast: unitItem.localcontrol_forecast || false,
      localmanagement_forecast: unitItem.localmanagement_forecast || false,
      regionalcontrol_forecast: unitItem.regionalcontrol_forecast || false,
      regionalmanagement_forecast: unitItem.regionalmanagement_forecast || false,
      bulkapprove_control: unitItem.bulkapprove_control || false,
      bulkapprove_management: unitItem.bulkapprove_management || false,
      usersflag: unitItem.allusersset === true ? "Yes" : "No",
      approver_list: unitItem?.approver || [],
      sodEnabled: unitItem?.sodEnabled || false,
      autoSubmissionEnabled: unitItem?.autoSubmissionEnabled || false,
      preparer_list: unitItem?.submitter || [],
      sod_status: unitItem?.sodEnabled ? varianceAnalysisConstants.SOD.STATUS.ENABLED : varianceAnalysisConstants.SOD.STATUS.DISABLED,
      regional_approver_list: unitItem?.regional_approver || [],
      manager_list: unitItem?.manager || [],
      type: unitItem?.type || "",
    });
  });

  return { formattedArray, ruCodeNameMap, ruCodeIdMap };
};

export const getInitialFilterOptions = (hierarchyData, labelsName, isViewOnly) => {
    const baseOptions = [
        // {
        //   value: 'name',
        //   key: 'year',
        //   data: hierarchyData.yearlist.map(y => ({ _id: String(y), name: String(y) })),
        //   name: labelsName('my_reporting_units_page', 'year_label', 'Year'),
        //   type: "singleselect"
        // },
        {
          value: 'name',
          key: 'period',
          data: hierarchyData.periodList.map(item => ( { _id: item._id, name: item.month + " - " + item.year })),
          name: labelsName('my_reporting_units_page', 'month_label', 'Period'),
          type: "singleselect"

        },
        {
          value: 'name',
          key: 'network',
          name: labelsName('my_reporting_units_page', 'division_label', 'Network'),
          data: (hierarchyData.network_detail || []).slice().sort((a, b) => (a.name || '').localeCompare(b.name || ''))
        },
        {
          value: 'name',
          key: 'region',
          data: (hierarchyData.region_detail || []).slice().sort((a, b) => (a.name || '').localeCompare(b.name || '')),
          name: labelsName('my_reporting_units_page', 'region_label', 'Region'),
        },
        {
          value: 'name',
          key: 'country',
          name: labelsName('my_reporting_units_page', 'country_label', 'Country'),
          data: (hierarchyData.country_detail || []).slice().sort((a, b) => (a.name || '').localeCompare(b.name || ''))
        },
        {
          value: 'reportingunitTypes',
          key: 'reportingunitTypes',
          data: (hierarchyData.reportingunitTypes || []),
          name: labelsName('my_reporting_units_page','ru_entity_label','Reporting Unit')+ ' Types',
        },
        {
          value: 'code',
          key: 'code',
          name: labelsName('my_reporting_units_page', 'unit_code_label', 'RU code'),
          data: (hierarchyData?.name || []).map((id) => ({
            _id: id.code,
            code: id.code + " - " + id.name
          })).sort((a, b) => (a.code || '').localeCompare(b.code || '')),
        }
      ];

      if (isViewOnly) {
        return [
            {
              value: 'role',
              key: 'role',
              data: [
                {
                  role: 'Local Preparer',
                  _id: 'submitter'
                },
                {
                  role: 'Local Approver',
                  _id: 'approver'
                },
                {
                  role: 'Regional Approver',
                  _id: 'regional_approver'
                },
                {
                  role: 'Manager',
                  _id: 'manager'
                },
                {
                  role: 'View Only',
                  _id: 'general_user'
                }
              ],
              name: "Role"
            },

            {
              value: 'name',
              key: 'network',
              name: labelsName('my_reporting_units_page', 'division_label', 'Network'),
              defaultSelectAll: true,
              data: hierarchyData.network_detail
            },
            {
              value: 'name',
              key: 'region',
              data: hierarchyData.region_detail,
              name: labelsName('my_reporting_units_page', 'region_label', 'Region'),
              defaultSelectAll: true,
            },
            {
              value: 'name',
              key: 'country',
              name: labelsName('my_reporting_units_page', 'country_label', 'Country'),
              defaultSelectAll: true,
              data: hierarchyData.country_detail
            },
            {
              value: 'code',
              key: 'code',
              name: labelsName('my_reporting_units_page', 'unit_code_label', 'RU code'),
              defaultSelectAll: true,
              data: (hierarchyData?.name || []).map((id) => ({
                _id: id.code,
                code: id.code + " - " + id.name
              })),
            },
          ];
      }

      return baseOptions;
}
